module.exports = __webpack_public_path__ + "img/yh_jhimg.70e3d734.png";